import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import App from './components/App';
import NotFound from './components/NotFound';
import LogIn from './components/LogIn';
import AddUser from './components/AddUser';
import ViewUser from './components/ViewUser';
import Profile from './components/Profile';
import Avatar from './components/Avatar';
import Category from './components/Category';
import EditCategory from './components/EditCategory';
import Unit from './components/Unit';
import EditUnit from './components/EditUnit';
import AddProducts from './components/AddProducts';
import ViewProducts from './components/ViewProducts';
import EditProduct from './components/EditProduct';
import BendedAddPrice from './components/BendedAddPrice';
import BendedPriceList from './components/BendedPriceList';
import EditDimension from './components/EditDimension';
import EditUsers from './components/EditUsers';
import QuotationTab from './components/QuotationTab';
import OrderTab from './components/OrderTab'
import Inventory from './components/Inventory'
import PendingQuotation from './components/PendingQuotation'
import QuotationPUser from './components/QuotationPUser'
import QuotationAUser from './components/QuotationAUser'
import QuotationDUser from './components/QuotationDUser'
import QuotationTabEdit from './components/QuotationTabEdit';
import DeliveryReciept from './components/DeliveryReciept'
import InventoryOutProduct from './components/InventoryOutProduct'
import InventoryOutSheet from './components/InventoryOutSheet'
import StockCardProduct from './components/StockCardProduct'
import StockCardSheet from './components/StockCardSheet'
import QuotationTabView from './components/QuotationTabView'
import QuotationApproved from './components/QuotationApproved'
import DealTab from './components/DealTab'
import ReviewTab from './components/ReviewTab'
import QuotationClosed from './components/QuotationClosed'
import QuotationCUser from './components/QuotationCUser'
import ForDisplayTab from './components/ForDisplayTab'
import OrderView from './components/OrderView'
import PurchaseOrderViewTab from './components/PurchaseOrderViewTab'
import Delivery from './components/Delivery'
import DeliveryView from './components/DeliveryView'
import ReportsSales from './components/ReportsSales'
import ReportsProductInventory from './components/ReportsProductInventory'
import ReportsSheetsInventory from './components/ReportsSheetsInventory'
import ForDisplayUTab from './components/ForDisplayUTab'
import QuotationClosedAdmin from './components/QuotationClosedAdmin'
import OrderViewAdmin from './components/OrderViewAdmin'

import './index.css';
import createBrowserHistory from 'history/createBrowserHistory';



const Root = () => {
	const history = createBrowserHistory();
	return(
		<Router history={history}>
            <Switch>
                <Route exact path="/"  component={App} />
                <Route exact path="/login" component={LogIn}  />
                <Route exact path="/users"  component={ViewUser} />
                <Route exact path="/users/:uid/profile"  component={Profile} />
                <Route exact path="/users/:uid/avatar"  component={Avatar} />
                <Route exact path="/users/new"  component={AddUser} />
                <Route exact path="/users/:uid/edit"  component={EditUsers} />
                <Route exact path="/products"  component={ViewProducts} />
                <Route exact path="/category"  component={Category} />
                <Route exact path="/category/:cid/edit"  component={EditCategory} />
                <Route exact path="/unit"  component={Unit} />
                <Route exact path="/unit/:uid/edit"  component={EditUnit} />
                <Route exact path="/products/new"  component={AddProducts} />
                <Route exact path="/products/:pid/edit"  component={EditProduct} />
                <Route exact path="/dimension/new"  component={BendedAddPrice} />
                <Route exact path="/dimension"  component={BendedPriceList} />
                <Route exact path="/dimension/:did/edit"  component={EditDimension} />    
                <Route exact path="/quotation/new"  component={QuotationTab} />
                <Route exact path="/quotation/:qid/edit"  component={QuotationTabEdit} />
                <Route exact path="/purchaseorder/new"  component={OrderTab} />
                <Route exact path="/purchaseorder/list"  component={OrderView} />
                <Route exact path="/purchaseorder/:oid/view"  component={PurchaseOrderViewTab} />
                <Route exact path="/inventory/"  component={Inventory} />
                <Route exact path="/inventory/:id/out-product"  component={InventoryOutProduct} />
                <Route exact path="/inventory/:id/out-sheet"  component={InventoryOutSheet} />
                <Route exact path="/inventory/:id/view-product"  component={StockCardProduct} />
                <Route exact path="/inventory/:id/view-sheet"  component={StockCardSheet} />
                <Route exact path="/quotation/pending"  component={PendingQuotation} />
                <Route exact path="/quotation/deal"  component={QuotationClosed} />
                <Route exact path="/quotation/:qid/view"  component={QuotationTabView} />
                <Route exact path="/quotation/:qid/review"  component={ReviewTab} />
                <Route exact path="/quotation/:qid/show"  component={ForDisplayTab} />
                <Route exact path="/quotation/:qid/update"  component={DealTab} />
                <Route exact path="/quotation/approved"  component={QuotationApproved} />
                <Route exact path="/quotation/pendingU"  component={QuotationPUser} />
                <Route exact path="/quotation/approvedU"  component={QuotationAUser} />
                <Route exact path="/quotation/dealU"  component={QuotationCUser} />
                <Route exact path="/quotation/disapproved"  component={QuotationDUser} />
                <Route exact path="/delivery/new"  component={DeliveryReciept} />
                <Route exact path="/delivery/list"  component={Delivery} />
                <Route exact path="/delivery/:did/view"  component={DeliveryView} />
                <Route exact path="/reports/sales"  component={ReportsSales} />
                <Route exact path="/quotation/:qid/ushow"  component={ForDisplayUTab} />
                <Route exact path="/reports/inventory-product"  component={ReportsProductInventory} />
                <Route exact path="/reports/inventory-sheets"  component={ReportsSheetsInventory} />
                <Route exact path="/quotation/deal/admin"  component={QuotationClosedAdmin} />
                <Route exact path="/purchaseorder/list/admin"  component={OrderViewAdmin} />

                <Route component={NotFound} />
          
            </Switch>
    </Router>
	)
}



ReactDOM.render(<Root />, document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.js